<template>
  <v-col :cols="12" :lg="6" class="d-flex ga-5 align-center">
    <div class="d-flex ga-1 align-center input-data-text">
      <StatusIcon />
      <label class="calender-input-label text-capitalize" for="status"
        >status</label
      >
    </div>

    <div
      :style="{ backgroundColor: store.status.color }"
      class="status-input d-flex align-center justify-space-between"
    >
      <span @click="nextStatus" class="clicked-status">
        {{ store.status.title }}
      </span>
      <StatusMenu />
    </div>
  </v-col>
</template>

<script>
import { useTaskStore } from "@/store/taskStore";
import StatusIcon from "./icons/StatusIcon.vue";
import StatusMenu from "./StatusMenu.vue";

export default {
  name: "TaskStatus",
  components: {
    StatusIcon,
    StatusMenu,
  },
  data() {
    return {
      store: useTaskStore(),
      statusList: [
        { title: "To Do", key: "todo", color: "rgba(83, 100, 113, 1)" },
        {
          title: "In Progress",
          key: "progress",
          color: "rgba(0, 133, 255, 1)",
        },
        { title: "Completed", key: "completed", color: "rgba(0, 186, 52, 1)" },
      ],
    };
  },
  watch: {
    "store.status": {
      handler() {
        console.log(this.store.status);
      },
      deep: true,
    },
  },
  methods: {
    nextStatus() {
      const currentIndex = this.statusList.findIndex(
        (item) => item.title === this.store.status.title
      );
      const nextStatus =
        currentIndex < this.statusList.length - 1
          ? this.statusList[currentIndex + 1]
          : this.statusList[0];
      this.store.updateStatus(nextStatus);
    },
  },
};
</script>
